/**
 * 허브 출력 HUD(SR-RUN-03 · FS-03 · FS-04 로컬 화면) — 내 기계 허브의 가운데 불빛 · 5×5 화면(또는 흐르는 글자) · 소리.
 * 보일 것이 없으면 그리지 않는다(프로그램이 허브를 쓰지 않으면 화면이 예전과 같다). 상태는 lib/hubOutput(순수).
 */
import { useI18n } from "../i18n";
import { HUB_BEEP_SHOW_MS, hubColor, hubPixels, hubVisible, type HubView } from "../lib/hubOutput";

/** 이름을 번역하는 불빛 색(block-runtime LIGHT_COLORS 에서 off 를 뺀 것) */
const HUB_LIGHT_NAMES = new Set(["red", "orange", "yellow", "green", "blue", "violet", "white"]);

/** prime = 스파이크 프라임 판 기계(허브 이름을 교구 이름으로 · 2026-11-03) */
export function HubHud({ hub, now, prime = false }: { hub: HubView; now: number; prime?: boolean }) {
  const { t } = useI18n();
  if (!hubVisible(hub, now)) return null;
  const px = hubPixels(hub.display);
  const text = hub.display?.startsWith("text:") ? hub.display.slice(5) : null;
  const beep = hub.beepAt !== null && now - hub.beepAt < HUB_BEEP_SHOW_MS;
  return (
    <div className="pf-hud pf-hud--hub" role="status" data-testid="hud-hub">
      <span className="pf-hud__hubLabel">{t(prime ? "course.hud.hubPrime" : "course.hud.hub")}</span>
      {hub.light && (
        <i
          className="pf-hud__light"
          style={{ background: hubColor(hub.light) }}
          data-testid="hud-hub-light"
          data-color={hub.light}
          aria-label={t("course.hud.hubLight", {
            color: HUB_LIGHT_NAMES.has(hub.light)
              ? t(`course.hud.hubColor.${hub.light}`)
              : hub.light,
          })}
        />
      )}
      {px && px.some((b) => b > 0) && (
        <span className="pf-hud__matrix" data-testid="hud-hub-matrix" aria-hidden="true">
          {px.map((b, i) => (
            <i key={i} style={{ opacity: b === 0 ? 0.12 : 0.25 + (b / 9) * 0.75 }} />
          ))}
        </span>
      )}
      {text !== null && (
        <span className="pf-hud__hubText" data-testid="hud-hub-text">
          {text}
        </span>
      )}
      {beep && (
        <span data-testid="hud-hub-beep" aria-label={t("course.hud.hubBeep")}>
          🔔
        </span>
      )}
    </div>
  );
}
